/* DowPickerComponent.js */

"use strict";
const Renderer = require("./DowPickerRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class DowPickerComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
}
module.exports = DowPickerComponent;
